import {
    MainFilterSelectedValuesAdditionalType,
    MainFilterSelectedValuesIdsAdditionalKeyEnum,
} from './main-filter-api-type';
import {
    FilterSuggestionType,
    GroupOperationsEnum,
    IsPaidFieldOptionsEnum,
    IsPriorityPlacementFieldNameEnum,
    NeedModerateFieldOptionsEnum,
} from './main-filter-type';

export function getSuggestionIds(values: Array<FilterSuggestionType> | boolean | null): Array<string> | null | boolean {
    return typeof values !== 'boolean' && values !== null ? values?.map((value) => value.id) : values;
}

export function caseForOpen(
    closedHookValue: Array<FilterSuggestionType>
): Partial<MainFilterSelectedValuesAdditionalType> {
    const selectedIds = closedHookValue?.map((suggestion) => suggestion.id) || [];

    if (selectedIds.length === 0) {
        return {};
    }

    return {
        [MainFilterSelectedValuesIdsAdditionalKeyEnum.CLOSED]: selectedIds,
    };
}

export function caseForActive(closedHookValue: Array<FilterSuggestionType>): MainFilterSelectedValuesAdditionalType {
    const initialState = {
        active: false,
        inactive: false,
    };

    const responseObject = Object.fromEntries(
        closedHookValue?.map((suggestion) => suggestion.id)?.map((option) => [option, true])
    );

    const assignedObject = Object.assign(initialState, responseObject);

    if (assignedObject.active && !assignedObject.inactive) {
        return {
            [MainFilterSelectedValuesIdsAdditionalKeyEnum.ACTIVE]: getSuggestionIds(true),
        };
    }

    if (!assignedObject.active && assignedObject.inactive) {
        return {
            [MainFilterSelectedValuesIdsAdditionalKeyEnum.ACTIVE]: getSuggestionIds(false),
        };
    }

    return {};
}

export function getGroupsOperationValue(groupsOrerationValue: Array<FilterSuggestionType>): GroupOperationsEnum {
    if (groupsOrerationValue.map(({id}) => id).includes(GroupOperationsEnum.AND)) {
        return GroupOperationsEnum.AND;
    }

    return GroupOperationsEnum.OR;
}

export function getIsPaidValue(isPaidValue: Array<FilterSuggestionType>): IsPaidFieldOptionsEnum {
    const values = new Set(isPaidValue.map(({id}) => id));

    if (values.has(IsPaidFieldOptionsEnum.PAID)) {
        return IsPaidFieldOptionsEnum.PAID;
    }

    if (values.has(IsPaidFieldOptionsEnum.NOT_PAID)) {
        return IsPaidFieldOptionsEnum.NOT_PAID;
    }

    return IsPaidFieldOptionsEnum.ALL;
}

const isPaidSerializedValueMap: Record<IsPaidFieldOptionsEnum, boolean | undefined> = {
    [IsPaidFieldOptionsEnum.PAID]: true,
    [IsPaidFieldOptionsEnum.NOT_PAID]: false,
    // eslint-disable-next-line no-undefined
    [IsPaidFieldOptionsEnum.ALL]: undefined,
};

export function serializeIsPaid(value: IsPaidFieldOptionsEnum): boolean | undefined {
    return isPaidSerializedValueMap[value];
}

export function getNeedModerateValue(needModerateValue: Array<FilterSuggestionType>): NeedModerateFieldOptionsEnum {
    const values = new Set(needModerateValue.map(({id}) => id));

    if (values.has(NeedModerateFieldOptionsEnum.YES)) {
        return NeedModerateFieldOptionsEnum.YES;
    }

    if (values.has(NeedModerateFieldOptionsEnum.NO)) {
        return NeedModerateFieldOptionsEnum.NO;
    }

    return NeedModerateFieldOptionsEnum.ALL;
}

const needModerateSerializedValueMap = {
    [NeedModerateFieldOptionsEnum.YES]: true,
    [NeedModerateFieldOptionsEnum.NO]: false,
    // eslint-disable-next-line no-undefined
    [NeedModerateFieldOptionsEnum.ALL]: undefined,
};

export function serializeNeedModerate(value: NeedModerateFieldOptionsEnum): boolean | undefined {
    return needModerateSerializedValueMap[value];
}

export function getPriorityPlacementValue(
    priorityPlacementValue: Array<FilterSuggestionType>
): IsPriorityPlacementFieldNameEnum {
    const values = new Set(priorityPlacementValue.map(({id}) => id));

    if (values.has(IsPriorityPlacementFieldNameEnum.PRIORITY_PLACEMENT)) {
        return IsPriorityPlacementFieldNameEnum.PRIORITY_PLACEMENT;
    }

    if (values.has(IsPriorityPlacementFieldNameEnum.NOT_PRIORITY_PLACEMENT)) {
        return IsPriorityPlacementFieldNameEnum.NOT_PRIORITY_PLACEMENT;
    }

    return IsPriorityPlacementFieldNameEnum.ALL;
}

const priorityPlacementSerializedValueMap: Record<IsPriorityPlacementFieldNameEnum, boolean | undefined> = {
    [IsPriorityPlacementFieldNameEnum.PRIORITY_PLACEMENT]: true,
    [IsPriorityPlacementFieldNameEnum.NOT_PRIORITY_PLACEMENT]: false,
    // eslint-disable-next-line no-undefined
    [IsPriorityPlacementFieldNameEnum.ALL]: undefined,
};

export function serializePriorityPlacement(value: IsPriorityPlacementFieldNameEnum): boolean | undefined {
    return priorityPlacementSerializedValueMap[value];
}
